// ============================================================================
// AUTH CONTEXT
// 
// Provides authentication state to the entire app
// Contains: user, tenant
// ============================================================================

import { createContext, useContext } from "react";

export const AuthContext = createContext(null);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthContext.Provider");
  return ctx;
}
